import * as React from 'react';

import AccountLink from 'bundles/third-party-auth/components/AccountLink';
import thirdPartyAuth from 'bundles/third-party-auth/lib';

import _t from 'i18n!nls/account-settings';

class AccountLinkingPreferences extends React.Component {
  state = {
    showFacebook: thirdPartyAuth.facebook.enabled,
    componentDidMount: false,
  };

  componentDidMount() {
    thirdPartyAuth.facebook.init();
    this.setState(() => ({ componentDidMount: true }));
  }

  render() {
    const { componentDidMount, showFacebook } = this.state;
    if (componentDidMount && showFacebook) {
      return (
        <div className="rc-AccountLinkingPreferences">
          <h2 className="display-2-text section-title">{_t('Linked Accounts')}</h2>
          <AccountLink />
        </div>
      );
    } else {
      return false;
    }
  }
}

export default AccountLinkingPreferences;
